import { gql, useQuery } from '@apollo/client';
import {
  GetRecipeTagsQuery,
  GetRecipeTagsQueryVariables,
  TagWhereInput,
} from '../../__generated__/queries-recipe';
import { client } from '../index';

export const GET_RECIPE_TAGS = gql`
  query GetRecipeTags($where: TagWhereInput!) {
    tags(where: $where, first: 50) {
      id
      title
      recipeTagCount
    }
  }
`;

export const getTags = (excludedIds: string[]) => async (query: string) => {
  const { data, errors } = await client.query<
    GetRecipeTagsQuery,
    GetRecipeTagsQueryVariables
  >({
    query: GET_RECIPE_TAGS,
    variables: {
      where: { title_contains: query || undefined },
    },
  });
  if (errors?.length) {
    throw errors[0];
  }

  return (
    // eslint-disable-next-line fp/no-mutating-methods
    data?.tags
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      .filter(({ id }) => !excludedIds.includes(id!))
      .sort(
        ({ recipeTagCount }, { recipeTagCount: next }) =>
          (next || 0) - (recipeTagCount || 0),
      )
      .map(({ id, title, recipeTagCount }) => ({
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        id: id!,
        label: `${title} (${recipeTagCount})`,
      }))
  );
};

export const useGetTags = (where: TagWhereInput) =>
  useQuery<GetRecipeTagsQuery, GetRecipeTagsQueryVariables>(GET_RECIPE_TAGS, {
    variables: { where },
  });
